import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
  
    const token = localStorage.getItem('token');

    if (token) {
      return of(true); // Token exists, allow navigation
    } else {
      
      this.router.navigate(['']);
      return of(false); // Prevent navigation
    }
  }
}
